import { createFileRoute } from '@tanstack/react-router'
import { ChallengesPage } from '../../components'

export const Route = createFileRoute('/challenges/available')({
  component: () => <ChallengesPage />,
})
